import ReactSelect from 'react-select'

import { useWindowDimensions } from '@hooks/use-window-dimensions'
import { stylesSelect } from '@components/v2/SimulationBanner/components/select/styles-select'
import { Label } from '../label'

interface SelectProps {
  name: string
  labelText: string
  placeholder: string
  options: {
    id: number
    name: string
  }[]
  value?: {
    value: number
    label: string
  }
  className?: string
  isError?: boolean
  onChange?: (data: any) => void
  maxMenuHeight?: number
  isSearchable?: boolean
}

export const Select = ({
  name,
  labelText,
  placeholder,
  options,
  value,
  className = '',
  isError,
  onChange,
  maxMenuHeight,
  isSearchable = true
}: SelectProps) => {
  const { width } = useWindowDimensions()

  const selectCustomStyles = stylesSelect({ width, isError })

  return (
    <div className={`flex flex-col ${className}`}>
      <Label htmlFor={name}>{labelText}</Label>

      <ReactSelect
        name={name}
        id={name}
        instanceId={name}
        options={options.map(item => {
          return { label: item.name, value: item.id }
        })}
        value={value}
        placeholder={placeholder}
        noOptionsMessage={() => 'Nenhuma distribuidora'}
        onChange={onChange}
        maxMenuHeight={maxMenuHeight}
        styles={selectCustomStyles}
        isDisabled={options.length === 0}
        isSearchable={isSearchable}
        openMenuOnFocus={true}
      />
    </div>
  )
}
